import React from "react";
import { appDomain } from "../../domain/AppDomain";
import { AppRoutes } from '../../domain/navigation/AppRoutes';
import { IEmployeeGroup } from "../../domain/employeeGroups/IEmployeeGroup";
import { BaseComponent } from "../core/BaseComponent";
import { EmployeeGroupListTableHeader } from "./EmployeeGroupListTableHeader";
import { EmployeeGroupListTableRow } from "./EmployeeGroupListTableRow";
interface EmployeeGroupListTableProps {
}
interface EmployeeGroupListTableState {
    groups: IEmployeeGroup[];
    isLoading: boolean;
}


export class EmployeeGroupListTable extends BaseComponent<EmployeeGroupListTableProps, EmployeeGroupListTableState> {
    componentDidMount() {
        this.getEmployeeGroups();
    }
    async getEmployeeGroups() {
        const employeeGroups = await appDomain.IEmployeeGroupService.getEmployeeGroups();
        this.setStateWhenMounted({ groups: employeeGroups });
    }
    async removeEmployeeGroup(employeeGroup: IEmployeeGroup) {
        if (window.confirm("Wilt u de personeelsgroep verwijderen?")) {
            await appDomain.IEmployeeGroupService.deleteEmployeeGroup(employeeGroup);
            await this.getEmployeeGroups();
        }
    }
    render() {
        if (this.state && this.state.groups) {
            const employeeGroups = this.state.groups;
            const tableRows: JSX.Element[] = [];
            employeeGroups.forEach(d => tableRows.push(<EmployeeGroupListTableRow key={(d.id || "").toString()} employeeGroup={d} onClick={() => this.navigateTo(`${AppRoutes.employeegroups}/${d.id}`)} onRemove={() => this.removeEmployeeGroup(d)} />));
            return (<table className="dagoverzicht">
                <EmployeeGroupListTableHeader />
                <tbody>
                    {tableRows}
                </tbody>
            </table>);
        }
        return null;
    }
}
